import * as Yup from 'yup';
//types
import {IOrganizationTableTicketsResponse} from '@/utils/types';
//validation
import {emailSchema, phoneSchema} from '@/utils/validation';

export const initialValues: IOrganizationTableTicketsResponse = {
  id: 0,
  tableInfoId: 0,
  tableInfo: {
    id: 0,
    tier: '',
    numberOfSeats: 0,
    amount: 0,
    price: 0,
    eventId: 0,
    fairMarketValue: 0,
    displayRemainingTickets: true,
    remainingTicketsThresholdValue: 0,
    isTicketsVisibleOnAuction: true,
    privatePurchaseUrl: null,
  },
  name: '',
  number: 0,
  isPaid: false,
  tickets: [
    {
      id: 0,
      email: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      meals: [],
      isVIP: false,
      isUnknown: false,
    },
  ],
  purchaserId: 0,
  purchaser: {
    id: 0,
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    meals: [],
    isVIP: false,
    isUnknown: false,
  },
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  tableInfo: Yup.object().shape({
    price: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return parseFloat(originalValue.replace(',', '.'));
        }
        return value;
      })
      .required('Price is a required')
      .typeError('Price must be a number')
      .positive('Price must be a positive')
      .min(0.01, 'Minimum price is 0.01')
      .test(
        'maxDigitsAfterDecimal',
        'Max two decimal places',
        (number) => number === undefined || number === null || Number.isInteger(number * 100)
      ),
    fairMarketValue: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return parseFloat(originalValue.replace(',', '.'));
        }
        return value;
      })
      .nullable()
      .typeError('Price must be a number')
      .positive('Price must be a positive')
      .min(0.01, 'Minimum price is 0.01')
      .test(
        'maxDigitsAfterDecimal',
        'Max two decimal places',
        (number) => number === undefined || number === null || Number.isInteger(number * 100)
      ),
  }),
  purchaser: Yup.object().shape({
    email: emailSchema,
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    phoneNumber: phoneSchema,
  }),
  tickets: Yup.array().of(
    Yup.object().shape(
      {
        email: emailSchema.nullable().optional(),
        firstName: Yup.string().when(['email', 'lastName', 'phoneNumber', 'meals'], {
          is: (email: string, lastName: string, phoneNumber: string, meals: unknown[]) =>
            !!email?.trim() || !!lastName?.trim() || !!phoneNumber?.trim() || (meals && meals.length > 0),
          then: () => Yup.string().required('First name is required'),
          otherwise: () => Yup.string().nullable().optional(),
        }),
        lastName: Yup.string().when(['email', 'firstName', 'phoneNumber', 'meals'], {
          is: (email: string, firstName: string, phoneNumber: string, meals: unknown[]) =>
            !!email?.trim() || !!firstName?.trim() || !!phoneNumber?.trim() || (meals && meals.length > 0),
          then: () => Yup.string().required('Last name is required'),
          otherwise: () => Yup.string().nullable().optional(),
        }),
        phoneNumber: phoneSchema.nullable(),
        meals: Yup.array(),
      },
      [
        ['email', 'firstName'],
        ['email', 'lastName'],
        ['email', 'phoneNumber'],
        ['email', 'meals'],
        ['firstName', 'lastName'],
        ['firstName', 'phoneNumber'],
        ['firstName', 'meals'],
        ['lastName', 'phoneNumber'],
        ['lastName', 'meals'],
        ['phoneNumber', 'meals'],
      ]
    )
  ),
});
